import { useCallback } from "react";
import { getColumnsWithGroup } from "../../api/Windows";
import { logCustomMessage } from "../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { GetColumnsWithGroupField } from "../../models/windows/GetColumnsWithGroup";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetWoCompletionFields() {
  const setWoCompletionFields = useWorkOrderStore(
    (state) => state.setWoCompletionFields
  );

  const getFields = useCallback((metadata: any) => {
    const fields: GetColumnsWithGroupField[] = [];
    const keys = Object.keys(metadata?.fields);
    for (const key of keys) {
      const field = metadata?.fields[key] as GetColumnsWithGroupField;
      fields.push(field);
    }
    return fields.sort((a, b) => {
      return +a.FieldOrder - +b.FieldOrder;
    });
  }, []);

  const getWoCompletionFields = useCallback(async () => {
    const response = await getColumnsWithGroup({
      WindowName: "mob_completion",
      IncludeValidValues: "true",
    });

    const fieldData = {
      WindowName: "mob_completion",
      IncludeValidValues: "true",
    };

    logCustomMessage(
      "Get Fields in Complete screen",
      SeverityLevel.Information,
      "Windows/GetColumnsWithGroup",
      fieldData,
      response
    );
    const fields = getFields(response.data);
    setWoCompletionFields(fields);
    return response;
  }, [getFields, setWoCompletionFields]);

  return { getWoCompletionFields };
}
